import useLicenseValidityForSubject from 'license/hooks/useLicenseValidityForSubject';
import { LICENSE_SUBJECTS } from 'license/constants';

const useCollectionActionCondition = () => {
  const {
    data: { valid: isValidLicense },
    isInitialLoading: isLoadingLicense,
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);

  if (isLoadingLicense) {
    return false;
  }

  return isValidLicense;
};

export default useCollectionActionCondition;
